module.exports = __webpack_public_path__ + "img/gr.41733700.svg";